import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Content, InterviewInputProps } from '../types';

interface InterViewSelectProps extends InterviewInputProps {
  contents: Content[];
}

export const InterViewSelect = (props: InterViewSelectProps) => {
  const handleChange = (e: SelectChangeEvent<number | number[]>) => {
    const selectedItem = props.contents?.find((item) => item.id === Number(e.target.value));
    if (props.sub) {
      props.onChange({
        ...props.answers,
        id: props.id,
        sub: { value: Number(e.target.value), label: selectedItem?.label ?? '' }
      });
    } else {
      props.onChange({
        ...props.answers,
        id: props.id,
        value: Number(e.target.value),
        label: selectedItem?.label ?? ''
      });
    }
  };

  if (props.sub) {
    return (
      <Select
        value={(props.answers && props.answers.sub && props.answers.sub.value) ?? ''}
        onChange={handleChange}
        displayEmpty
        fullWidth
        size="small"
        className="bg-white"
        inputProps={{ 'aria-label': 'Without label' }}
      >
        <MenuItem value=""></MenuItem>
        {props.contents.map((item, index) => (
          <MenuItem key={index} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    );
  } else {
    return (
      <Select
        value={(props.answers && props.answers.value) ?? ''}
        onChange={handleChange}
        displayEmpty
        fullWidth
        size="small"
        className="bg-white"
        inputProps={{ 'aria-label': 'Without label' }}
      >
        <MenuItem value=""></MenuItem>
        {props.contents.map((item, index) => (
          <MenuItem key={index} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    );
  }
};
